module.exports = __webpack_public_path__ + "static/co_founder_header-44703e3257b0efc2541cab36af43d1f0.png";